var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnchance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5615 17.7861L23.5815 29.1541C23.6041 29.288 23.5853 29.4256 23.5276 29.5485C23.4699 29.6714 23.3761 29.7737 23.2587 29.8419C23.1413 29.91 23.0058 29.9407 22.8705 29.9297C22.7352 29.9188 22.6064 29.8669 22.5014 29.7808L17.7281 26.1981C17.4977 26.026 17.2178 25.933 16.9301 25.933C16.6425 25.933 16.3626 26.026 16.1321 26.1981L11.3508 29.7795C11.2459 29.8654 11.1173 29.9173 10.9821 29.9282C10.847 29.9391 10.7117 29.9086 10.5943 29.8406C10.477 29.7727 10.3832 29.6706 10.3253 29.5479C10.2675 29.4253 10.2485 29.2879 10.2708 29.1541L12.2894 17.7861",
    stroke: "#155DFC",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9258 19.2666C21.3441 19.2666 24.9258 15.6849 24.9258 11.2666C24.9258 6.84832 21.3441 3.2666 16.9258 3.2666C12.5075 3.2666 8.92578 6.84832 8.92578 11.2666C8.92578 15.6849 12.5075 19.2666 16.9258 19.2666Z",
    stroke: "#155DFC",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnchance);
export default __webpack_public_path__ + "static/media/Enchance.903a880805b9b03d7a39f9995247f017.svg";
export { ForwardRef as ReactComponent };